AgrimarketControllers.controller('userContractsOptionMonitoringController', ['$scope', '$rootScope', '$routeParams', 'configurationFactory',
    'contractsOptionService', '$sce', '$filter', 'colonnesContractsOptionExpired', 'colonnesContractsOptionPending',
    function ($scope, $rootScope, $routeParams, configurationFactory, contractsOptionService, $sce, $filter, colonnesContractsOptionExpired, colonnesContractsOptionPending) {

        
    }]);
 